// src/components/CredentialManagement/CredentialsSection.js
import React from "react";
import PropTypes from "prop-types";
import CredentialList from "./CredentialList";

/**
 * CredentialsSection - Main credentials section with header and loading state
 *
 * Displays device credentials in a collapsible section with loading overlay.
 * Coordinates the display of credential list and manages section state.
 */
const CredentialsSection = ({
  credentials,
  credentialsLoaded,
  isCollapsed,
  onToggleCollapse,
  selectedDeviceId,
  patronsMap,
  pendingDeletionCredentials,
  offlineDeviceCredentials,
  devicesWithPendingDeletions,
  onDeleteCredential,
  dragHandleProps,
}) => {
  return (
    <section className="credential-container">
      <h2
        onClick={onToggleCollapse}
        className="draggable-header"
        {...dragHandleProps}
      >
        Device Credentials ({credentials.length})
        <span className="collapse-icon">{isCollapsed ? "▼" : "▲"}</span>
      </h2>

      {!credentialsLoaded && (
        <div className="credential-loading-overlay">
          <span className="hourglass-flip">⏳</span>
          <span className="loading-text">Syncing Latest State...</span>
        </div>
      )}

      {!isCollapsed && (
        <CredentialList
          credentials={credentials}
          selectedDeviceId={selectedDeviceId}
          patronsMap={patronsMap}
          pendingDeletionCredentials={pendingDeletionCredentials}
          offlineDeviceCredentials={offlineDeviceCredentials}
          devicesWithPendingDeletions={devicesWithPendingDeletions}
          onDeleteCredential={onDeleteCredential}
        />
      )}
    </section>
  );
};

CredentialsSection.propTypes = {
  credentials: PropTypes.array.isRequired,
  credentialsLoaded: PropTypes.bool.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  onToggleCollapse: PropTypes.func.isRequired,
  selectedDeviceId: PropTypes.string.isRequired,
  patronsMap: PropTypes.object.isRequired,
  pendingDeletionCredentials: PropTypes.instanceOf(Set).isRequired,
  offlineDeviceCredentials: PropTypes.instanceOf(Set).isRequired,
  devicesWithPendingDeletions: PropTypes.instanceOf(Set).isRequired,
  onDeleteCredential: PropTypes.func.isRequired,
  dragHandleProps: PropTypes.object,
};

export default CredentialsSection;
